import { render, staticRenderFns } from "./FootballTeamCardBody.vue?vue&type=template&id=7d54ebe0&scoped=true&"
import script from "./FootballTeamCardBody.vue?vue&type=script&lang=js&"
export * from "./FootballTeamCardBody.vue?vue&type=script&lang=js&"
import style0 from "./FootballTeamCardBody.vue?vue&type=style&index=0&id=7d54ebe0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d54ebe0",
  null
  
)

export default component.exports